import { routes } from "@/common/utils/routes";
import { IShortUser } from "@/common/services/types";
import { useNewVerifiedCreators } from "@/common/queries/queries";
import { UserListWidgetAlive } from "@/components/widgets/UserListWidgetAlive";
import { IUserInfo } from "@/components/widgets/types";

export const NewCreators = (): JSX.Element => {
  const creators = useNewVerifiedCreators();

  if (creators.isError) {
    return <p>Error loading creators.</p>;
  }

  const items = creators.data ? creators.data.creators.map((el: IShortUser): IUserInfo => ({
    id: el.username,
    name: el.name ?? el.username,
    image: el.profileImageUrl ?? undefined,
    following: false,
    verified: el.verified,
  })) : [];

  return (
    <UserListWidgetAlive
      className="newCreators"
      title="🎉 Newly Verified Creators"
      link={routes.exploreCreators("recent", true)}
      items={items}
      list={true}
    />
  );
};
